import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';

/**
 * DELETE /api/eraf/roles/{id} — 역할 소프트 삭제
 */
export function useDeleteRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => roleApi.delete(id),
    onSuccess: (_data, id) => {
      queryClient.removeQueries({ queryKey: ['role-management', 'detail', id] });
      void queryClient.invalidateQueries({ queryKey: ['role-management', 'list'] });
    },
  });
}
